<template>
  <v-card class="shortcut-box" flat>
    <header class="shortcut-header">
      <div class="shortcut-eyebrow">Pikasuodatus</div>
      <h3 class="shortcut-title">Joukkue ulkokentällä</h3>
      <div class="shortcut-subtitle">
        Avaa suodatus, kun joukkue on ulkopelissä
      </div>
    </header>

    <div class="shortcut-body">
      <div v-if="!canFilter" class="shortcut-empty">
        Valitse joukkue ja kausi.
      </div>

      <table v-else class="shortcut-table">
        <thead>
          <tr>
            <th class="col-label">Lyönti</th>
            <th
              v-for="state in baseStates"
              :key="`th-${state.value}`"
              class="col-state"
            >
              {{ state.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="row-all">
            <td class="col-label">Kaikki</td>
            <td
              v-for="state in baseStates"
              :key="`cell-all-${state.value}`"
              class="col-state"
            >
              <button
                v-tooltip="`Suodatus: &quot;Kaikki lyönnit - ${state.label} til&quot;`"
                type="button"
                class="state-btn"
                @click="openFilter(null, state.value)"
              >
                <v-icon size="14">mdi-play</v-icon>
              </button>
            </td>
          </tr>
          <tr v-for="hitNumber in hitNumbers" :key="`row-${hitNumber}`">
            <td class="col-label">{{ hitNumber }}.</td>
            <td
              v-for="state in baseStates"
              :key="`cell-${hitNumber}-${state.value}`"
              class="col-state"
            >
              <button
                v-tooltip="`Suodatus: &quot;${hitNumber}. lyönti - ${state.label} til&quot;`"
                type="button"
                class="state-btn"
                @click="openFilter(hitNumber, state.value)"
              >
                <v-icon size="14">mdi-play</v-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { buildFilterUrl } from '@/utils/joukkueet/filterUrl'

export default {
  name: 'OutfieldFilterShortcutBox',
  props: {
    leagueId: {
      type: Number,
      default: null
    },
    leagueClubId: {
      type: Number,
      default: null
    },
    seasonId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    hitNumbers: [1, 2, 3],
    baseStates: [
      { value: '0', label: '0' },
      { value: '1', label: '1' },
      { value: '1-2', label: '1-2' },
      { value: 'Ajo', label: 'Ajo' },
      { value: '1-3', label: '1-3' }
    ]
  }),
  computed: {
    ...mapGetters('user', [
      'currentTeamId'
    ]),
    canFilter() {
      return Boolean(this.leagueId && this.leagueClubId && this.seasonId && this.currentTeamId)
    }
  },
  methods: {
    openFilter(hitNumber, baseState) {
      if(!this.canFilter) return

      const url = buildFilterUrl({
        season: this.seasonId,
        upClubs: [this.leagueClubId],
        hit_number: hitNumber === null ? ['all'] : [hitNumber],
        bases_state: [baseState],
        league_id: this.leagueId,
        team_id: this.currentTeamId
      })

      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }
}
</script>

<style scoped>
.shortcut-box {
  margin-top: 24px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.shortcut-header {
  padding: 20px 24px 12px;
  border-bottom: 1px solid #e5e7eb;
}

.shortcut-eyebrow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 4px;
}

.shortcut-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
}

.shortcut-subtitle {
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}

.shortcut-body {
  padding: 8px 0;
}

.shortcut-empty {
  padding: 24px;
  text-align: center;
  color: #6b7280;
  font-size: 13px;
}

.shortcut-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.shortcut-table thead th {
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  text-align: center;
}

.shortcut-table thead th.col-label {
  text-align: left;
}

.shortcut-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
}

.shortcut-table tbody tr:last-child {
  border-bottom: none;
}

.shortcut-table tbody tr:hover {
  background: #fafafa;
}

.shortcut-table tbody tr.row-all {
  background: #fafafa;
  border-bottom: 1px solid #e5e7eb;
}

.shortcut-table tbody tr.row-all .col-label {
  color: #374151;
}

.shortcut-table td {
  padding: 10px 16px;
  vertical-align: middle;
  text-align: center;
  color: #111827;
}

.col-label {
  width: 80px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #6b7280;
  text-align: left;
}

.col-state {
  text-align: center;
}

.state-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}

.state-btn:hover:not(:disabled) {
  background: #f3f4f6;
  border-color: #e5e7eb;
  color: #111827;
}
</style>
